"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flag = void 0;
const evaluateFlags_1 = require("./evaluateFlags");
const flagsClient_1 = require("./flagsClient");
const getDefinitions_1 = require("./getDefinitions");
const flag = async (flag, context = {}, options) => {
    const revalidate = options?.fetchOptions?.next?.revalidate !== undefined
        ? options?.fetchOptions?.next?.revalidate
        : 15;
    try {
        const definitions = await (0, getDefinitions_1.getDefinitions)({
            ...options,
            fetchOptions: {
                next: { revalidate },
                ...options?.fetchOptions,
            },
        });
        const { toggles } = await (0, evaluateFlags_1.evaluateFlags)(definitions, context);
        const client = (0, flagsClient_1.flagsClient)(toggles);
        return {
            enabled: client.isEnabled(flag),
            variant: client.getVariant(flag),
        };
    }
    catch (error) {
        return {
            enabled: false,
            variant: {},
            error,
        };
    }
};
exports.flag = flag;
